import React from "react";
import PlusButton from "../buttons/PlusButton";
import WatchButton from "../buttons/WatchButton";
import "./TvDesc.scss";

const TvDesc = ({ title }) => {
  return (
    <div className="tv-desc">
      <div className="tv-desc__name">{title}</div>
      <div className="tv-desc__user">
        <div className="tv-desc__gener">Drama, Action, Thriller</div>
        <div className="tv-desc__match">94% Match</div>
      </div>
      <div className="tv-desc__buttons">
        <WatchButton />
        <PlusButton />
      </div>
    </div>
  );
};

export default TvDesc;
